import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AppInsightsService } from "@api/services/app-insights/app-insights.service";
import { AuthService } from "@auth/services/auth/auth.service";
import { SessionStorageService } from "@shared/services/session-storage.service";
import { AzaraWrapperComponent } from "@shared/components/azara-wrapper/azara-wrapper.component";

@Component({
    selector: "app-unauthorized",
    templateUrl: "./unauthorized.component.html",
    styleUrl: "./unauthorized.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AzaraWrapperComponent],
})
export class UnauthorizedComponent {
    private readonly appInsightsService = inject(AppInsightsService);
    private readonly authService = inject(AuthService);
    private readonly sessionService = inject(SessionStorageService);

    public handleSignoutClicked(): void {
        this.appInsightsService.clearContext();
        this.sessionService.clearAcwState();
        this.authService.logout();
    }
}
